import React, { isValidElement, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { dataModel } from '../dataModel';
import { SingleProductSpecifications } from './SingleProductSpecifications';
import { track } from '../specifications-analytics';
import { MultiProductSpecifications } from './MultiProductSpecifications';
import { CONFIGURATOR_ITEM_IDS_EVENT, isEventBusCreated } from '../helpers';

export const SpecificationsAccordionBodyComponent = (props) => {
  const {
    itemId,
    children,
    oneColumn,
    returnableStatus,
    isWhiteSpecTitle
  } = props;

  const [itemIds, setItemIds] = useState([itemId]);

  useEffect(() => {
    if (itemId) {
      setItemIds([itemId]);
    }
  }, [itemId]);

  useEffect(() => {
    if (isEventBusCreated()) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on(CONFIGURATOR_ITEM_IDS_EVENT, ({ output }) => {
        setItemIds(output.itemIds);
      });
    }
    return () => {
      if (isEventBusCreated()) {
        window.LIFE_CYCLE_EVENT_BUS.lifeCycle.off(CONFIGURATOR_ITEM_IDS_EVENT);
      }
    };
  }, []);

  useEffect(() => { track('accordion-open'); }, []);

  if (!itemIds || itemIds.length === 0) {
    return null;
  }

  return (
    itemIds.length > 1
      ? (
        <MultiProductSpecifications itemIds={itemIds}>
          {children}
        </MultiProductSpecifications>
      )
      : (
        <SingleProductSpecifications
          itemId={itemIds[0]}
          oneColumn={oneColumn}
          returnableStatus={returnableStatus}
          isWhiteSpecTitle={isWhiteSpecTitle}
        >
          {children}
        </SingleProductSpecifications>
      )
  );
};

SpecificationsAccordionBodyComponent.displayName = 'SpecificationsAccordionBodyComponent';

SpecificationsAccordionBodyComponent.dataModel = dataModel;

const propTypes = {
  /** SKU Number */
  itemId: PropTypes.string.isRequired,
  returnableStatus: PropTypes.bool,
  /** Can take an (optional) single child component of type KeyProductFeatures */
  children: (props, propName, componentName) => {
    const prop = props[propName];
    let error;
    if (prop && (!isValidElement(prop) || prop.type.name !== 'KeyProductFeatures')) {
      error = new Error(`'${componentName}' only accepts a single child of type 'KeyProductFeatures'`);
    }
    return error;
  },
  oneColumn: PropTypes.bool,
  isWhiteSpecTitle: PropTypes.bool
};

const defaultProps = {
  children: null,
  oneColumn: false,
  returnableStatus: false,
  isWhiteSpecTitle: false
};

SpecificationsAccordionBodyComponent.propTypes = propTypes;
SpecificationsAccordionBodyComponent.defaultProps = defaultProps;

export const SpecificationsAccordionBody = withErrorBoundary(SpecificationsAccordionBodyComponent);

SpecificationsAccordionBody.dataModel = dataModel;
SpecificationsAccordionBody.propTypes = propTypes;
SpecificationsAccordionBody.defaultProps = defaultProps;
